<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    listThemes() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/themes`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>